<template>
  <div class="mt-5 position-relative">
    <div class="px-2 text-light py-2 bg-success mx-3 border-3 rounded textos">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        fill="currentColor"
        class="bi bi-pen my-1"
        viewBox="0 0 16 16"
      >
        <path
          d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z"
        />
      </svg>
      EDITAR POSTULANTE
    </div>

    <div class="position-relative py-1 px-5">
      <div v-if="alerta" class="alert alert-info" role="alert">
        ¡Se realizó con éxito los siguientes cambios!
      </div>
    </div>

    <div class="py-1 mx-3">
      <div class="row">
        <div class="col-lg-4 col-sm-12 py-2">
          <h5 class="tamaño">Tipo Documento:</h5>
          <!-- {{ form.DesTipDocumento }} -->
          <select
            class="form-select"
            @change="dosomething($event)"
            aria-label="Default select example"
          >
            <option selected disabled>{{ desTipDocumento }}</option>
            <option
              :value="arreglarItems.parCorrelativo"
              v-for="arreglarItems in Arreglar"
              :key="arreglarItems.id"
            >
              {{ arreglarItems.parDescripcion }}
            </option>
          </select>
        </div>
        <div class="form-group col-lg-4 col-sm-12 py-1">
          <h5 class="tamaño">N° Documento:</h5>
          <input
            type="number"
            class="form-control mt-1"
            v-model="form.posNroDocumento"
            id="exampleFormControlInput1"
          />
        </div>

        <div class="col-sm-12 col-lg-4 py-2">
          <h5 class="tamaño">Género:</h5>
          <!-- {{ form.DesTipDocumento }} -->
          <select
            class="form-select"
            @change="Generosi($event)"
            aria-label="Default select example"
          >
            <option selected disabled>{{ desGenero }}</option>
            <option
              :value="generoItems.parCorrelativo"
              v-for="generoItems in Genero"
              :key="generoItems.id"
            >
              {{ generoItems.parDescripcion }}
            </option>
          </select>

          {{ form.desGenero }}
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 col-sm-12 py-2">
          <h5 class="tamaño">Estado Civil:</h5>
          <select
            class="form-select"
            @change="EstadoCivil($event)"
            aria-label="Default select example"
          >
            <option selected disabled>{{ desEstCivil }}</option>
            <option
              :value="estadoCivil.parCorrelativo"
              v-for="estadoCivil in EstadoCiviles"
              :key="estadoCivil.id"
            >
              {{ estadoCivil.parDescripcion }}
            </option>
          </select>

          {{ form.desGenero }}
        </div>

        <div class="col-lg-4 col-sm-12 py-2">
          <h5 class="tamaño">País:</h5>
          <select
            class="form-select"
            @change="Pais($event)"
            aria-label="Default select example"
          >
            <option selected disabled>{{ desPais }}</option>
            <option
              :value="paisEstados.parCorrelativo"
              v-for="paisEstados in PaisEstado"
              :key="paisEstados.id"
            >
              {{ paisEstados.parDescripcion }}
            </option>
          </select>

          {{ form.desGenero }}
        </div>

        <div class="col-lg-4 col-sm-12 py-2">
          <h5 class="tamaño">Nacionalidad:</h5>
          <select
            class="form-select"
            @change="Nacion($event)"
            aria-label="Default select example"
          >
            <option selected disabled>{{ desNacionalidad }}</option>
            <option
              :value="nacionEstados.parCorrelativo"
              v-for="nacionEstados in NacionEstado"
              :key="nacionEstados.id"
            >
              {{ nacionEstados.parDescripcion }}
            </option>
          </select>

          {{ form.desGenero }}
        </div>

        <div class="col-lg-4 col-sm-12 py-2">
          <h5 class="tamaño">Estado:</h5>
          <select
            class="form-select"
            @change="Estado($event)"
            aria-label="Default select example"
          >
            <option selected disabled>{{ desEstado }}</option>
            <option
              :value="EstadoStatuse.parCorrelativo"
              v-for="EstadoStatuse in EstadoStatus"
              :key="EstadoStatuse.id"
            >
              {{ EstadoStatuse.parDescripcion }}
            </option>
          </select>

          {{ form.desGenero }}
        </div>

        <div class="col-lg-4 col-sm-12 py-2">
          <h5 class="tamaño">Departamento:</h5>
          <select
            class="form-select"
            @change="DepartamentoEvent($event)"
            aria-label="Default select example"
          >
            <option selected disabled>{{ desDepartamento }}</option>
            <option
              :value="departamentoDistritos.idParametro"
              v-for="departamentoDistritos in DepartamentoDistrito"
              :key="departamentoDistritos.id"
            >
              {{ departamentoDistritos.parDescripcion }}
            </option>
          </select>
        </div>

        <div class="col-lg-4 col-sm-12 py-2">
          <h5 class="tamaño">Provincia:</h5>
          <select
            class="form-select"
            @change="ProvinciaEvent($event)"
            aria-label="Default select example"
          >
            <option selected disabled>{{ desProvincia }}</option>
            <option
              :value="provinciaDepas.idParametro"
              v-for="provinciaDepas in provinciaDepa"
              :key="provinciaDepas.id"
            >
              {{ provinciaDepas.parDescripcion }}
            </option>
          </select>
        </div>

        <div class="col-lg-4 col-sm-12 py-2">
          <h5 class="tamaño">Distrito:</h5>
          <select
            class="form-select"
            @change="DistritoEvent($event)"
            aria-label="Default select example"
          >
            <option selected disabled>{{ desDistrito }}</option>
            <option
              :value="distritoProvins.parCorrelativo"
              v-for="distritoProvins in distritoProvin"
              :key="distritoProvins.id"
            >
              {{ distritoProvins.parDescripcion }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="py-1 mx-3">
      <div class="row">
        <div class="form-group col-lg-3 col-sm-12 py-3">
          <h5 class="tamaño">Nombres:</h5>
          <input
            type="text"
            class="form-control mt-2"
            v-model="form.posNombre"
            id="exampleFormControlInput1"
          />
        </div>

        <div class="form-group col-lg-3 col-sm-12 py-3">
          <h5 class="tamaño">Apellido Materno:</h5>
          <input
            type="text"
            class="form-control mt-2"
            v-model="form.posApeMaterno"
            id="exampleFormControlInput1"
          />
        </div>

        <div class="form-group col-lg-3 col-sm-12 py-3">
          <h5 class="tamaño">Apellido Paterno:</h5>
          <input
            type="text"
            class="form-control mt-2"
            v-model="form.posApePaterno"
            id="exampleFormControlInput1"
          />
        </div>

        <div class="form-group col-lg-3 col-sm-12 py-3">
          <h5 class="tamaño">Nacimiento:</h5>
          <input
            class="form-control mt-2"
            v-model="form.posFecNacimiento"
            id="exampleFormControlInput1"
          />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-lg-3 col-sm-12 py-3">
          <h5 class="tamaño">Teléfono:</h5>
          <input
            type="number"
            class="form-control mt-2"
            v-model="form.posTelefono"
            id="exampleFormControlInput1"
          />
        </div>

        <div class="form-group col-lg-3 col-sm-12 py-3">
          <h5 class="tamaño">Teléfono Adicicional:</h5>
          <input
            type="number"
            class="form-control mt-2"
            v-model="form.posTelAdicional"
            id="exampleFormControlInput1"
          />
        </div>

        <div class="form-group col-lg-6 col-sm-12 py-3">
          <h5 class="tamaño">Perfil Profesional</h5>
          <input
            type="text"
            class="form-control mt-2"
            v-model="form.posPerProfesional"
            id="exampleFormControlInput1"
          />
        </div>
      </div>
      <div class="row">
       
        <div class="form-group col-lg-4 col-sm-12 py-3">
          <h5 class="tamaño">Ocupación:</h5>
          <input
            type="text"
            class="form-control mt-2"
            v-model="form.posOcupacion"
            id="exampleFormControlInput1"
          />
        </div>

        <div class="form-group col-lg-4 col-sm-12 py-3">
          <h5 class="tamaño">Correo:</h5>
          <input
            type="email"
            class="form-control mt-2"
            v-model="form.posCorreo"
            id="exampleFormControlInput1"
          />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-lg-4 col-sm-12 py-3">
          <h5 class="tamaño">Usuario Creado:</h5>
          <input
            type="text"
            class="form-control mt-2"
            :disabled="isdisabled"
            v-model="posUsuCreado"
            id="exampleFormControlInput1"
          />
        </div>

        <div class="form-group col-lg-4 col-sm-12 py-3">
          <h5 class="tamaño">Pos Correo:</h5>
          <input
            type="text"
            class="form-control mt-2"
            :disabled="isdisabled"
            v-model="posCorreoEnviado"
            id="exampleFormControlInput1"
          />
        </div>

        <div class="form-group col-lg-4 col-sm-12 py-3">
          <h5>Estado Convocatoria:</h5>
          <input
            type="text"
            class="form-control mt-2"
            v-model="form.posEstadoConvoca"
            id="exampleFormControlInput1"
          />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-lg-3 col-sm-12 py-3">
          <h5 class="tamaño">Cantidad Hijos:</h5>
          <input
            type="number"
            class="form-control mt-2"
            v-model="form.posCanHijos"
            id="exampleFormControlInput1"
          />
        </div>


        <div class="form-group col-lg-3 col-sm-12 py-3">
          <h5 class="tamaño">Hijos Menores:</h5>
          <input
            type="number"
            class="form-control mt-2"
            v-model="form.posHijosMen"
            id="exampleFormControlInput1"
          />
        </div>
        <div class="form-group col-lg-6 col-sm-12 py-3">
          <h5 class="tamaño">Dirección:</h5>
          <input
            type="text"
            class="form-control mt-2"
            v-model="form.posDireccion"
            id="exampleFormControlInput1"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 col-sm-12 py-2">
          <h5 class="tamaño">Grado Académico:</h5>
          <select
            class="form-select"
            @change="GradoAcademico($event)"
            aria-label="Default select example"
          >
            <option selected disabled>{{ desGradoAcademico }}</option>
            <option
              :value="gradoAcademicos.parCorrelativo"
              v-for="gradoAcademicos in gradoAcademico"
              :key="gradoAcademicos.id"
            >
              {{ gradoAcademicos.parDescripcion }}
            </option>
          </select>        

        </div>

        <div class="form-group col-lg-6 col-sm-12 py-3">
          <h5 class="tamaño">Estudios Superiores:</h5>
          <input
            type="text"
            class="form-control mt-2"
            v-model="form.posEstudios"
            id="exampleFormControlInput1"
          />
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-3">
      <button class="btn btn-success mx-2 mb-3 px-5 py-2" @click="guardar">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="26"
          fill="currentColor"
          class="bi bi-pen my-1"
          viewBox="0 0 16 16"
        >
          <path
            d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z"
          />
        </svg>
        EDITAR
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "SolimanologEditarListado",

  props: {
    numeroDocument: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      file1: null,
      doc: [],
      // seleccionado: "",
      alerta: false,
      posUsuCreado: "",
      posCorreoEnviado: "",
      isdisabled: true,
      desTipDocumento: "",
      desGenero: "",
      desEstCivil: "",
      desPais: "",
      desNacionalidad: "",
      desEstado: "",
      desDepartamento: "",
      desGradoAcademico:"",
      desProvincia: "",
      desDistrito: "",

      form: {
        idPostulante: "",
        posTipDocumento: "",
        posNroDocumento: "",
        posUbigeo: "",
        posNombre: "",
        posApePaterno: "",
        posApeMaterno: "",
        posFecNacimiento: "",
        posGenero: "",
        posEstCivil: "",
        posTelefono: "",
        posTelAdicional: "",
        // CodProvincia:"",
        posPais: "",
        posNacionalidad: "",
        posPerProfesional: "",
        posAdjunto: "",
        posEstado: "",
        posOcupacion: "",
        posCorreo: "",

        posCanHijos: "",
        posDireccion: "",
        posHijosMen: "",
        posGradoAcademico: "",
        posEstudios: "",
        modPostulante: false,
        posEstadoConvoca: "",
        posComBloqueo: ""
        
        // posDatos:""
      },

      // selectedFile: "",
      selectedFileNombre:"",
      provinciaDepa: [],
      distritoProvin: [],

      gradoAcademico:[]
    };
  },

  mounted() {
    console.log(this.numeroDocument);

    // this.form.idPostulante = this.$route.params.dni;
    this.form.idPostulante = this.numeroDocument;
    console.log(this.form.idPostulante);

    this.axios.get("ParametroData/Parametro/2475").then(r =>{
      console.log(r.data)
      this.gradoAcademico = r.data
    })

    this.axios
      .get("Postulante/ObtenerPostulante/" + this.form.idPostulante)
      .then((datos) => {
        console.log("si funciona perro");
        console.log(datos.data);
        this.doc = datos.data;
        this.desTipDocumento = datos.data.desTipDocumento;
        this.desGenero = datos.data.desGenero;
        this.desEstCivil = datos.data.desEstCivil;
        this.desPais = datos.data.desPais;
        this.desNacionalidad = datos.data.desNacionalidad;
        this.desEstado = datos.data.desEstado;
        this.desDepartamento = datos.data.desDepartamento;
        this.desProvincia = datos.data.desProvincia;
        this.desDistrito = datos.data.desDistrito;
        this.form.posUbigeo = datos.data.posUbigeo;
        this.desGradoAcademico = datos.data.desGradoAcademico
        // this.form.CodProvincia = datos.data.CodProvincia
        // this.seleccionado = this.form.DesTipDocumento;
        // console.log(this.form.DesTipDocumento);
        this.form.posTipDocumento = datos.data.posTipDocumento;
        this.form.posNroDocumento = datos.data.posNroDocumento;
        this.form.posNombre = datos.data.posNombre;
        this.form.posApePaterno = datos.data.posApePaterno;
        this.form.posApeMaterno = datos.data.posApeMaterno;
        this.form.posFecNacimiento = datos.data.posFecNacimiento.slice(0, 10);
        this.form.posGenero = datos.data.posGenero;
        this.form.posEstCivil = datos.data.posEstCivil;
        this.form.posTelefono = datos.data.posTelefono;
        this.form.posTelAdicional = datos.data.posTelAdicional;
        this.form.posPais = datos.data.posPais;
        this.form.posNacionalidad = datos.data.posNacionalidad;
        this.form.posPerProfesional = datos.data.posPerProfesional;
        this.form.posAdjunto = datos.data.posAdjunto;
        this.form.posEstado = datos.data.posEstado;
        this.form.posOcupacion = datos.data.posOcupacion;
        this.form.posCorreo = datos.data.posCorreo;
        this.posUsuCreado = datos.data.posUsuCreado;
        this.posCorreoEnviado = datos.data.posCorreoEnviado;
        this.form.posCanHijos = datos.data.posCanHijos;
        this.form.posDireccion = datos.data.posDireccion;
        this.form.posHijosMen = datos.data.posHijosMen;
        this.form.posGradoAcademico = datos.data.posGradoAcademico;
        this.form.posEstudios = datos.data.posEstudios;
        this.form.posEstadoConvoca = datos.data.posEstadoConvoca
        this.form.posComBloqueo = datos.data.posComBloqueo;

        // this.form.posDatos =datos.data.posDatos
      });
  },
  computed: {
    ...mapGetters("parametros", [
      "Arreglar",
      "Genero",
      "EstadoCiviles",
      "PaisEstado",
      "EstadoStatus",
      "DepartamentoDistrito",
      "NacionEstado",
    ]),
    ...mapGetters("listadoPostulante", ["Postulante"]),
  },

  created() {},
  methods: {
    ...mapActions("listadoPostulante", ["editar"]),

    // editare(){
    //   this.editar(this.form)
    // },

    guardar(){

      const fd = new FormData();

      fd.append("IdPostulante", this.form.idPostulante);
      fd.append("PosTipDocumento", this.form.posTipDocumento);
      fd.append("PosNroDocumento", this.form.posNroDocumento);
      fd.append("PosNombre", this.form.posNombre);
      fd.append("PosApePaterno", this.form.posApePaterno);
      fd.append("PosApeMaterno", this.form.posApeMaterno);
      fd.append("PosFecNacimiento", this.form.posFecNacimiento);
      fd.append("PosGenero", this.form.posGenero);
       fd.append("PosEstCivil", this.form.posEstCivil);
       fd.append("PosTelefono", this.form.posTelefono);
      fd.append("PosTelAdicional", this.form.posTelAdicional);
      fd.append("PosPais", this.form.posPais);
      fd.append("PosUbigeo", this.form.posUbigeo);
      fd.append("PosNacionalidad", this.form.posNacionalidad);
      fd.append("PosPerProfesional", this.form.posPerProfesional);
    
      fd.append("PosEstado", this.form.posEstado);
       fd.append("PosOcupacion", this.form.posOcupacion);
       fd.append("PosCorreo", this.form.posCorreo);
      fd.append("PosCanHijos", this.form.posCanHijos);
      fd.append("PosDireccion", this.form.posDireccion);
      fd.append("PosHijosMen", this.form.posHijosMen);
      fd.append("PosGradoAcademico", this.form.posGradoAcademico);
      fd.append("PosEstudios", this.form.posEstudios);
      fd.append("PosAdjunto", this.form.posAdjunto);
      fd.append("ArchivoPos", this.form.posAdjunto);
      fd.append("modPostulante", this.form.modPostulante);
      fd.append("posComBloqueo", this.form.posComBloqueo);



      console.log(this.form)
       this.editar(fd)

    },
    onFileSelected(event) {
      this.form.posAdjunto = event.target.files[0];
    
    },

    GradoAcademico(event){
      this.form.posGradoAcademico = event.target.value
    },

    dosomething(event) {
      this.form.posTipDocumento = event.target.value;

      console.log(event.target.value);
    },
    Generosi(event) {
      this.form.posGenero = event.target.value;
      console.log(this.Postulante);
      console.log(event.target.value);
    },
    EstadoCivil(event) {
      this.form.posEstCivil = event.target.value;
      console.log(event.target.value);
    },
    Pais(event) {
      this.form.posPais = event.target.value;
      console.log(event.target.value);
    },
    Nacion(event) {
      this.form.posNacionalidad = event.target.value;
      console.log(event.target.value);
    },

    Estado(event) {
      this.form.posEstado = event.target.value;
      console.log(event.target.value);
    },
    DepartamentoEvent(event) {
      let departamento = event.target.value;

      this.getAttributeDepartParms(departamento),
        console.log(event.target.value);
    },

    getAttributeDepartParms(id) {
      this.axios.get(`ParametroData/Parametro/${id}`).then((datos) => {
        this.provinciaDepa = datos.data;
      });
    },

    ProvinciaEvent(event) {
      console.log(event.target.value);
      let province = event.target.value;

      this.axios.get(`DistritoData/Listar/${province}`).then((datos) => {
        this.distritoProvin = datos.data;
      });
    },

    DistritoEvent(event) {
      this.form.posUbigeo = event.target.value;
      console.log(this.form.posUbigeo);
    },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 2%;
  margin-right: 2%;
  height: 100%;
  border-radius: 10px 10px 10px 10px;
  overflow-x: none;
  overflow-y: hidden;
}

.textos {
  font-size: 1.56rem;
}

.tamaño {
  font-size: 0.95rem;

  font-weight: 700;
  color: #002c5d;
}

</style>
